import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExtractConsumerRequest, ExtractRequest } from '../models/request/extract-request';
import { ResponseBase } from '../models/response-base';
import { ExtractResponse, ExtractConsumerResponse } from '../models/response/extract-response';

@Injectable({
  providedIn: 'root'
})
export class ExtractService {
    API: String = environment.EXTRACT
    private URL = environment.GATEWAY + "lambda/extrato/consumidor";

    constructor(private http: HttpClient) { }

    getExtract(extractRequest: ExtractRequest): Observable<ResponseBase<ExtractResponse>>{

        return this.http.post<ResponseBase<ExtractResponse>>(`${this.API}`, extractRequest);
    }

    getExtractConsumer(extractConsumerRequest: ExtractConsumerRequest): Observable<ResponseBase<ExtractConsumerResponse>>{
      return this.http.post<ResponseBase<ExtractConsumerResponse>>(`${this.URL}`, extractConsumerRequest);
    }
}
